import React from 'react';
import PropTypes from 'prop-types';
import { EVENT_NAMES } from '../../../constants';

class ResponseRow extends React.Component {
  static propTypes = {
    eventName: PropTypes.string,
    goal: PropTypes.number,
    responseInterval: PropTypes.number,
    timeStamp: PropTypes.string
  }

  weeklyUpdate = (timeStamp) => {
    const date = new Date(timeStamp);
    return (
      <div>
        <div>{date.toLocaleDateString()} </div>
        <div>{date.toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' })}</div>
      </div>
    );
  }

    displayInterval = (value) => {
      const interval = Number(value);
      const h = Math.floor(interval / 3600);
      const m = Math.floor(interval % 3600 / 60);
      const s = Math.floor(interval % 3600 % 60);

      let firstColon = '';
      let secondColon = '';

      const hDisplay = h > 0 ? h + 'h ' : ' ';
      const mDisplay = m > 0 ? m + 'm ' : ' ';
      const sDisplay = s > 0 ? s + 's ' : ' ';

      if (h > 0 && m > 0) {
        firstColon = ': ';
      }

      if (m > 0 && s > 0) {
        secondColon = ': ';
      }

      if (h > 0 && s > 0 && m < 1) {
        firstColon = '';
        secondColon = ': ';
      }

      return hDisplay + firstColon + mDisplay + secondColon + sDisplay;
    }

    render () {
      const { eventName, goal, responseInterval, timeStamp } = this.props;

      let goalSet = '';
      let intervalSet = '';
      let interveralFormat = '';
      let isWeeklyUpdate = false;
      let isBonus = false;
      let isStandard = false;

      if (eventName === EVENT_NAMES.WELCOME_BONUS) {
        isBonus = true;
        goalSet = ' ';
        intervalSet = ' ';
        interveralFormat = 'interval-bonus';
      } else if (eventName === EVENT_NAMES.WEEKLY_UPDATE) {
        isWeeklyUpdate = true;
        goalSet = 'Goal: By Tuesday 8:00 AM';
        intervalSet = this.weeklyUpdate(timeStamp);
        interveralFormat = (responseInterval > goal) ? 'interval-red' : 'interval-green';
      } else {
        isStandard = true;
        goalSet = `Goal: ${this.displayInterval(goal)} or less`;
        if (eventName === EVENT_NAMES.APPOINTMENT_OUTCOME && Number(responseInterval) < 0) {
          intervalSet = 'On time';
        } else {
          intervalSet = this.displayInterval(responseInterval);
        }
        interveralFormat = (responseInterval > goal) ? 'interval-red' : 'interval-green';
      }

      return (
        <React.Fragment>
          {
            isWeeklyUpdate &&
            <div className='score-list-item'>
              <div className='float-left '> {eventName}</div>
              <div className={interveralFormat}>{intervalSet}</div>
              <div className='small text-muted align-top'>{goalSet}</div>
            </div>
          }
          {isBonus &&
          <div className='score-list-item score-list-bonus'>
            <div className='goal-text'> {eventName}</div>
          </div>
          }

          { isStandard &&
          <div className='score-list-item'>
            <div className='float-left '> {eventName} </div>
            <div className={interveralFormat}>{intervalSet}</div>
            <div className='small text-muted align-top goal-text'>{goalSet}</div>
          </div>
          }

        </React.Fragment>
      );
    }
}

export default ResponseRow;
